import cn from "classnames";
import { useTranslation } from "next-i18next";

import Modal from "@components/Modal/Modal";
import i from "@styles/icons.module.scss";
import Button from "@ui-kit/Button/Button";

import s from "./SearchPassengersMobile.module.scss";

const passengersInfoType = {
  // child: 'Children of pre-school age (up to 7 yo, 7 incl.)',
  // youth: 'Children up to 16 y. (incl.)',
  // senior: 'Seniors above 60 y. (60 incl.)',
  passengers: "passengers",
};

const SearchPassengersMobile = ({
  isOpen,
  toggleModal,
  passengers,
  updatePassengers,
  passengersCount,
  preschoolChildWarning,
}) => {
  const { t } = useTranslation();
  return (
    <Modal className={s.modal} isOpen={isOpen} onRequestClose={toggleModal}>
      <header className={s.header}>
        <h2>{t("passengers")}</h2>
      </header>
      <div className={s.passengers}>
        {Object.keys(passengers).map((type) => (
          <div className={s.type} key={type}>
            <div className={s.name}>
              <div className={s.text}>
                {t(`passengers.type.${type}.title`, {
                  count: passengers[type],
                })}
              </div>
              <div className={s.info}>{t(`passengers.type.${type}.info`)}</div>
            </div>
            <div className={s.controls}>
              <div
                onClick={() => updatePassengers(type, passengers[type] - 1)}
                className={cn(
                  s.button,
                  s.minus,
                  (passengersCount <= 0 || passengers[type] === 0) &&
                    s.disabled,
                )}
              >
                <icon className={i.minus} />
              </div>
              <div className={s.count}>{passengers[type]}</div>
              <div
                className={cn(s.button, "plus")}
                onClick={() => updatePassengers(type, passengers[type] + 1)}
              >
                <icon className={i.plus_v2} />
              </div>
            </div>
          </div>
        ))}
        {preschoolChildWarning && (
          <div className={s.warning}>
            {t("passengers.preschoolChildWarning")}
          </div>
        )}
      </div>
      <div className={s.continue}>
        <Button className={s.button} onClick={toggleModal}>
          {t("continue")}
        </Button>
      </div>
    </Modal>
  );
};

export default SearchPassengersMobile;
